import * as React from "react";
import {Component } from "react";
import {observer} from "mobx-react";
import {Popup} from "semantic-ui-react";

import "./project-type-icon.scss";

import {GeoICONS, Icon} from "../../core/components/icon/icon";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";

export interface ProjectTypeIconProps {
    auftragsverwaltung: Auftragsverwaltung;
    typeId: number | null;
}

@observer
export class ProjectTypeIcon extends Component<ProjectTypeIconProps, any> {
    constructor(props: ProjectTypeIconProps) {
        super(props);
        this.state = {
            typeCodes: null
        };
    }

    componentDidMount(): void {
        this.loadDomains();
    }

    componentWillUnmount(): void {}

    render(): React.ReactElement | null {
        const {typeId} = this.props;
        const {typeCodes} = this.state;

        if (!typeCodes) {
            return null;
        }

        return (
            <Popup content={typeCodes.get(typeId)}
                trigger={
                    <Icon name={this.iconName} className={`project-type-icon project-type-code-${typeId}`} />
                }
            />
        );
    }

    /**
     * Return icon name based on type
     * @private
     */
    private get iconName(): GeoICONS {
        const {typeId} = this.props;
        switch(typeId) {
        case 1: {
            // Gefahrenkarte
            return "sign_warning";
        }
        case 2: {
            // Gefahrenhinweiskarte
            return "construction_barrier";
        }
        case 3: {
            // Gefahrenkarte und Gefahrenhinweiskarte
            return "sign_warning_harmful";
        }
        case 4: {
            // Risikoübersicht
            return "home_water";
        }
        default: {
            return "window_warning";
        }
        }
    }

    /**
     * Load domains
     *
     * @private
     */
    private loadDomains() {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.getShortDomainCodes("project", "typeId").then((typeCodes) => {
            this.setState({
                typeCodes
            });
        });
    }
}
